import React from "react";

import { ButtonProps } from "react-bootstrap";

import classNames from "classnames";

import BrandButton from "../BrandButton/BrandButton";

import styles from "./ButtonSmall.module.scss";

interface Props extends ButtonProps {
  children: React.ReactNode;
}

const ButtonSmall: React.FC<Props> = (props) => {
  const buttonClass = classNames([styles.customButton, props.className]);

  return (
    <BrandButton {...props} color="light" className={buttonClass}>
      {props.children}
    </BrandButton>
  );
};

export default ButtonSmall;
